import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { ModalModule } from "@modules/app-modal/modal.module";
import { SelectPaymentOptionComponent } from "./components/select-payment-option/select-payment-option.component";
import { TradableToViewModule } from "@modules/main/components/tradable-to-view-item/tradable-to-view.module";
import { DepositAmountComponent } from "./components/deposit-amount/deposit-amount.component";
import { FiatDepositGuard } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit.guard";
import { PaymentOptionTileComponent } from "@modules/+new/payments/features/fiat-deposit/components/select-payment-option/payment-options-tiles/payment-option-tile/payment-option-tile.component";
import { PaymentOptionsTilesComponent } from "@modules/+new/payments/features/fiat-deposit/components/select-payment-option/payment-options-tiles/payment-options-tiles.component";
import { SharedPaymentsModule } from "@modules/+new/payments/shared-payments/shared-payments.module";
import { PaymentOptionsModule } from "@modules/+new/payments/features/payment-options/payment-options.module";
import { DepositSurveyModule } from "@modules/+new/payments/features/deposit-survey/deposit-survey.module";
import { FiatPrecisionPipeModule } from "@modules/+new/shared/fiat-precision-pipe/fiat-precision-pipe.module";
import { FiatSymbolPipeModule } from "@modules/+new/shared/fiat-symbol-pipe/fiat-symbol-pipe.module";
import { FiatDepositRemote } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit.remote";
import { DepositSummaryComponent } from "@modules/+new/payments/features/fiat-deposit/components/deposit-summary/deposit-summary.component";
import { GetBestDepositReductionInfoPipe } from "@modules/+new/payments/features/fiat-deposit/components/select-payment-option/domain/pipes/get-best-deposit-reduction-info.pipe";
import { AssetListComponent } from "./components/select-wallet/components/asset-list-wrapper/asset-list/asset-list.component";
import { WalletsModule } from "@modules/+new/wallets/wallets.module";
import { SelectWalletFiltersComponent } from "./components/select-wallet/components/select-wallet-filters/select-wallet-filters.component";
import { SharedModule } from "@modules/+new/shared/shared.module";
import { AssetsModule } from "@modules/+new/assets/assets.module";
import { AssetListWrapperComponent } from "./components/select-wallet/components/asset-list-wrapper/asset-list-wrapper.component";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { TransactionsModule } from "@modules/+new/transactions/transactions.module";
import { ManualDepositModule } from "@modules/+new/payments/features/fiat-deposit/modules/manual-deposit/manual-deposit.module";
import { BankConnectorModule } from "@modules/+new/payments/features/fiat-deposit/modules/bank-connector/bank-connector.module";
import { BankSelectorModule } from "@modules/+new/payments/features/fiat-deposit/modules/bank-selector/bank-selector.module";
import { DepositPendingComponent } from "./components/deposit-pending/deposit-pending.component";
import { DelayedRedirectLinkComponent } from "@modules/+new/payments/features/fiat-deposit/components/deposit-pending/delayed-redirect-link/delayed-redirect-link.component";
import { DepositVerifyPinComponent } from "./components/deposit-verify-pin/deposit-verify-pin.component";
import { A11yModule } from "@angular/cdk/a11y";
import { SelectFiatWalletComponent } from "./components/select-wallet/components/select-fiat-wallet/select-fiat-wallet.component";
import { NonDefaultAddressComponent } from "@modules/+new/payments/features/crypto-deposit/components/non-default-address/non-default-address.component";
import { FilterModule } from "@modules/main/components/filters/filter.module";

@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		ModalModule,
		TradableToViewModule,
		SharedPaymentsModule,
		PaymentOptionsModule,
		FiatPrecisionPipeModule,
		FiatSymbolPipeModule,
		DepositSurveyModule,
		WalletsModule,
		SharedModule,
		AssetsModule,
		UniversalModalModule,
		BankSelectorModule,
		BankConnectorModule,
		TransactionsModule,
		ManualDepositModule,
		A11yModule,
		FilterModule
	],
	declarations: [
		SelectPaymentOptionComponent,
		DepositAmountComponent,
		PaymentOptionsTilesComponent,
		PaymentOptionTileComponent,
		DepositSummaryComponent,
		GetBestDepositReductionInfoPipe,
		AssetListComponent,
		SelectWalletFiltersComponent,
		AssetListWrapperComponent,
		DepositPendingComponent,
		DelayedRedirectLinkComponent,
		DepositVerifyPinComponent,
		SelectFiatWalletComponent,
		NonDefaultAddressComponent
	],
	exports: [AssetListWrapperComponent, SelectWalletFiltersComponent],
	providers: [FiatDepositGuard, FiatDepositRemote]
})
export class FiatDepositModule {}
